import apollo from '@/apollo.js'
import gql from 'graphql-tag'

export const createServiceLevelCriteria = async (data) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
      mutation createServiceLevelCriteria($bucketId: Int!, $name: String!, $jeopardyDays: Int!, $jeopardyHours: Int!, $jeopardyMinutes: Int!, $inJeopardyTaskId: Int!, $breachedDays: Int!, $breachedHours: Int!, $breachedMinutes: Int!, $inBreachTaskId: Int!, $enabled: Boolean!) {
          createServiceLevelCriteria(bucketId: $bucketId, name: $name, jeopardyDays: $jeopardyDays, jeopardyHours: $jeopardyHours, jeopardyMinutes: $jeopardyMinutes, inJeopardyTaskId: $inJeopardyTaskId, breachedDays: $breachedDays, breachedHours: $breachedHours, breachedMinutes: $breachedMinutes, inBreachTaskId: $inBreachTaskId, enabled: $enabled) {
            lowLevelErrorMessage
            message
            error
            id
            bucketId
            inJeopardyThreshold { days hours minutes taskId }
            inBreachThreshold { days hours minutes taskId }
            name
            enabled
          }
      }`),
      variables: {
        bucketId: data.bucketId,
        name: data.name,
        jeopardyDays: data.jeopardyDays,
        jeopardyHours: data.jeopardyHours,
        jeopardyMinutes: data.jeopardyMinutes,
        inJeopardyTaskId: data.inJeopardyTaskId,
        breachedDays: data.breachedDays,
        breachedHours: data.breachedHours,
        breachedMinutes: data.breachedMinutes,
        inBreachTaskId: data.inBreachTaskId,
        enabled: data.enabled
      }
    }
  )
  return response.data.createServiceLevelCriteria
}

export const updateServiceLevelCriteria = async (data) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
      mutation updateServiceLevelCriteria($id: Int!,$bucketId: Int!, $name: String!, $jeopardyDays: Int!, $jeopardyHours: Int!, $jeopardyMinutes: Int!, $inJeopardyTaskId: Int!, $breachedDays: Int!, $breachedHours: Int!, $breachedMinutes: Int!, $inBreachTaskId: Int!, $enabled: Boolean!) {
          updateServiceLevelCriteria(id: $id, bucketId: $bucketId, name: $name, jeopardyDays: $jeopardyDays, jeopardyHours: $jeopardyHours, jeopardyMinutes: $jeopardyMinutes, inJeopardyTaskId: $inJeopardyTaskId, breachedDays: $breachedDays, breachedHours: $breachedHours, breachedMinutes: $breachedMinutes, inBreachTaskId: $inBreachTaskId, enabled: $enabled) {
            lowLevelErrorMessage
            message
            error
          }
      }`),
      variables: {
        id: data.id,
        bucketId: data.bucketId,
        name: data.name,
        jeopardyDays: data.jeopardyDays,
        jeopardyHours: data.jeopardyHours,
        jeopardyMinutes: data.jeopardyMinutes,
        inJeopardyTaskId: data.inJeopardyTaskId,
        breachedDays: data.breachedDays,
        breachedHours: data.breachedHours,
        breachedMinutes: data.breachedMinutes,
        inBreachTaskId: data.inBreachTaskId,
        enabled: data.enabled
      }
    }
  )
  return response.data.updateServiceLevelCriteria
}

export const deleteServiceLevelCriteria = async (id) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
      mutation deleteServiceLevelCriteria($id: Int!) {
        deleteServiceLevelCriteria(id: $id) { error message lowLevelErrorMessage }
      }`),
      variables: { id: id }
    }
  )
  return response.data.deleteServiceLevelCriteria
}
